import DOMPurify from "dompurify";

const HTML_CONFIG: DOMPurify.Config = {
  ALLOW_DATA_ATTR: true,
};

const INLINE_TEXT_HTML_CONFIG: DOMPurify.Config = {
  ALLOWED_TAGS: [
    "b",
    "strong",
    "i",
    "em",
    "span",
  ],
  ALLOWED_ATTR: [
    "class",
  ],
  ALLOW_DATA_ATTR: true,
};

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, HTML_CONFIG);
}

export function sanitizeInlineTextHtml(html: string): string {
  return DOMPurify.sanitize(html, INLINE_TEXT_HTML_CONFIG);
}